import dayjs from 'dayjs'
import 'dayjs/locale/id'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import duration from 'dayjs/plugin/duration'
import axios from 'axios'
import * as XLSX from 'xlsx'

dayjs.extend(duration)
dayjs.extend(localeData)
dayjs.extend(localizedFormat)

export function formatDate(date, format = 'DD MMMM YYYY') {
  if (!date) return null;

  const dayjsDate = dayjs(date);

  if (!dayjsDate.isValid()) return null;

  return dayjsDate.locale('id').format(format);
}

export function getUrlFilename(url) {
  return url.substring(url.lastIndexOf('/') + 1, url.length)
}

export function downloadFile(fileUrl) {
  axios
    .get(fileUrl, { responseType: 'blob', 'Content-Disposition': 'attachment' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', getUrlFilename(fileUrl))
      document.body.appendChild(link)
      link.click()
    })
    .catch((error) => {})
}

export function formatIDR(number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(number)
}

export function formatDateString(dateStr, full = false) {
  const inputDate = dayjs(dateStr)
  const now = dayjs()

  if (inputDate.isSame(now, 'day')) {
    return inputDate.format('HH.mm')
  } else {
    return inputDate.format(full ? 'DD/MM/YYYY HH.mm' : 'DD/MM/YYYY')
  }
}

export async function openFileById(id_file) {
  const user = JSON.parse(localStorage.getItem('userPengendalian'))
  return axios
    .get(`${this.baseapiPengendalian}api/files/download/${id_file}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ` + user.accessToken,
      },
    })
    .then((res) => {
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    })
}

function sanitize(value) {
  if (value == null) return ''

  if (Array.isArray(value)) {
    return value.map(sanitize).join(', ')
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  if (typeof value === 'string') {
    return value
      // hapus control character
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '')
      // hapus Unicode noncharacter
      .replace(/[\uFFFE\uFFFF]/g, '')
      // optional: batasi panjang cell Excel
      .slice(0, 32767)
  }

  return value
}

export function exportToExcel({ data, header = {}, fileName = 'data' }) {
  if (!data || data.length === 0) {
    console.error('Data kosong, tidak bisa diexport.')
    return
  }

  const keys = Object.keys(header)
  const labels = Object.values(header)

  const excelData = [
    labels,
    ...data.map(item =>
      keys.map(key => sanitize(item[key]))
    )
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(excelData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  XLSX.writeFile(workbook, `${fileName}.xlsx`)
}

export function getDateFromNowMonths(months = 3) {
  return dayjs().add(months, 'month').format('YYYY-MM-DD')
}

export function hasRole(user, role) {
  const roles = Array.isArray(role) ? role : [role]
  if (Array.isArray(user.roles)) {
    return roles.some(r => user.roles.includes(r))
  }
  return roles.includes(user.role)
}

export function getUserUptScope(user = {}) {
  return user.nama_upt === 'PUSAT' ? 'pusat' : 'upt'
}

export function isVerifikatorPusat(user = {}) {
  return hasRole(user, 'Verifikator') && getUserUptScope(user) === 'pusat'
}

export function canAccessUptScope(user = {}, scope, requiredRole) {
  if (hasRole(user, 'Superuser')) {
    return true
  }

  if (!hasRole(user, requiredRole)) {
    return false
  }

  return getUserUptScope(user) === scope
}
